import { productRepo } from '../repo';

export const productService = {

    // PRODUCT TYPES
    async getProductTypes(params = {}) {
        try {
            const response = await productRepo.getProductTypes(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getActiveProductTypes() {
        try {
            const response = await productRepo.getActiveProductTypes();
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getProductTypeById(productTypeId) {
        if (!productTypeId) {
            throw new Error('Product type ID is required');
        }
        try {
            const response = await productRepo.getProductTypeById(productTypeId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async createProductType(data) {
        if (!data.name || data.name.length < 3) {
            throw new Error('Product type name must be at least 3 characters');
        }
        try {
            const response = await productRepo.createProductType(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async updateProductType(productTypeId, data) {
        if (!productTypeId) {
            throw new Error('Product type ID is required');
        }
        try {
            const response = await productRepo.updateProductType(productTypeId, data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async toggleProductTypeStatus(productTypeId) {
        if (!productTypeId) {
            throw new Error('Product type ID is required');
        }
        try {
            const response = await productRepo.toggleProductTypeStatus(productTypeId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    // PRODUCT CATEGORIES

    async getProductCategories(params = {}) {
        try {
            const response = await productRepo.getProductCategories(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getActiveProductCategories() {
        try {
            const response = await productRepo.getActiveProductCategories();
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getProductCategoriesByProductType(productTypeId) {
        if (!productTypeId) {
            throw new Error('Product type ID is required');
        }
        try {
            const response = await productRepo.getProductCategoriesByProductType(productTypeId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getProductCategoryById(productCategoryId) {
        if (!productCategoryId) {
            throw new Error('Product category ID is required');
        }
        try {
            const response = await productRepo.getProductCategoryById(productCategoryId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async createProductCategory(data) {
        if (!data.category_name || data.category_name.length < 3) {
            throw new Error('Category name must be at least 3 characters');
        }
        if (!data.product_type_id) {
            throw new Error('Product type is required');
        }
        try {
            const response = await productRepo.createProductCategory(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async updateProductCategory(productCategoryId, data) {
        if (!productCategoryId) {
            throw new Error('Product category ID is required');
        }
        try {
            const response = await productRepo.updateProductCategory(productCategoryId, data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async toggleProductCategoryStatus(productCategoryId) {
        if (!productCategoryId) {
            throw new Error('Product category ID is required');
        }
        try {
            const response = await productRepo.toggleProductCategoryStatus(productCategoryId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    // PRODUCTS
    
    async getProducts(params = {}) {
        try {
            const response = await productRepo.getProducts(params);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getActiveProducts() {
        try {
            const response = await productRepo.getActiveProducts();
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getProductById(productId) {
        if (!productId) {
            throw new Error('Product ID is required');
        }
        try {
            const response = await productRepo.getProductById(productId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getProductByCategory(productCategoryId) {
        if (!productCategoryId) {
            throw new Error('Product category ID is required');
        }
        try {
            const response = await productRepo.getProductByCategory(productCategoryId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async getPackageTypes() {
        try {
            const response = await productRepo.getPackageTypes();
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async createProduct(data) {
        if (!data.product_name || data.product_name.length < 3) {
            throw new Error('Product name must be at least 3 characters');
        }
        if (!data.package_type) {
            throw new Error('Package type is required');
        }
        if (!data.product_category_id) {
            throw new Error('Product category is required');
        }
        try {
            const response = await productRepo.createProduct(data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async updateProduct(productId, data) {
        if (!productId) {
            throw new Error('Product ID is required');
        }
        try {
            const response = await productRepo.updateProduct(productId, data);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    async toggleProductStatus(productId) {
        if (!productId) {
            throw new Error('Product ID is required');
        }
        try {
            const response = await productRepo.toggleProductStatus(productId);
            return response;
        } catch (error) {
            throw this.handleError(error);
        }
    },

    handleError(error) {
        console.error('ProductService Error:', error);
        return error.response?.data || error;
    },
};